import { graphql } from "../../gql";


export const reportErrorMutation = graphql(`#graphql
	mutation ReportError($errorReport: ErrorReport!) {
		reportError(errorReport: $errorReport)
	}
`);